<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Permohonan Swasta</h2>
    <Widget customHeader>
      <div>
        <table id="example" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nomor Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Provinsi</th>

              <th>Tgl. Permohonan</th>
              <!-- <th>Tgl. Berlaku Tagihan</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th>File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="index">
              <td></td>
              <td>
                <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                <span class="badge rounded-pill bg-danger" style="
                    font-size: 10px;
                    font-weight: normal;
                    background-color: #ff6e7c !important;
                  " v-else>Belum Ada</span>
              </td>
              <td>{{ data.jenis_kegiatan }}</td>
              <td>{{ data.provinsi }}</td>

              <td>
                {{ format_date(data.tanggal_permohonan, "DD MMM YYYY") }}
              </td>
              <!-- <td>
                <span v-if="data.status_tagihan_iii != null">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii,"DD MMMM YYYY") }}
                </span>
                <span
                  v-else-if="
                    data.status_tagihan_ii != null &&
                    data.status_tagihan_i != null
                  "
                >
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii,"DD MMMM YYYY") }}
                </span>
                <span v-else>
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_i,"DD MMMM YYYY") }}
                </span>
              </td> -->
              <td>
                {{ data.status_permohonan }}
              </td>
              <td>
                {{ data.keterangan_status }}
              </td>
              <td>
                <div style="min-width: 170px">
                  <b-button variant="light" size="sm"
                    class="rounded-pill text-primary font-weight-bold shadow-sm border-0 px-3 py-2 d-flex align-items-center justify-content-between w-100"
                    @click="openModalDownload(data)">
                    <div class="d-flex align-items-center">
                      <i class="fa fa-folder-open mr-2 text-primary"></i>
                      <span>Unduh Dokumen</span>
                    </div>

                    <b-badge v-if="countAvailableFiles(data) > 0" variant="primary" pill class="px-2 py-1 ml-1">
                      {{ countAvailableFiles(data) }}
                    </b-badge>
                  </b-button>
                </div>
              </td>
              <td>
                <div style="min-width: 280px">
                  <div class="d-flex align-items-center flex-wrap" style="gap: 6px;">

                    <!-- Tombol Pembayaran (Kondisional) -->
                    <b-button v-if=" data.status_permohonan != 'Selesai' &&
                      (
                        data.file_tagihan_i != null ||
                        data.file_tagihan_ii != null ||
                        data.file_tagihan_iii != null
                      )" variant="light" size="sm"
                      class="rounded-pill text-warning font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="getBayar(data.id)">
                      <i class="fa fa-money mr-2"></i>
                      <span>Pembayaran</span>
                    </b-button>

                    <!-- Tombol Tracking (Selalu Tampil) -->
                    <b-button variant="light" size="sm"
                      class="rounded-pill text-success font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="loadProgress(data.id)">
                      <i class="fa fa-search mr-2"></i>
                      <span>Tracking</span>
                    </b-button>

                    <!-- Tombol Edit (Kondisional Status Permohonan) -->
                    <b-button v-if="
                      data.status_permohonan == 'Data telah dibuat oleh pemohon' ||
                      data.status_permohonan == 'Permohonan telah disubmit oleh pemohon' ||
                      data.status_permohonan == 'Permohonan telah dibuat oleh pemohon' ||
                      data.status_permohonan == 'Permohonan telah disubmit ulang oleh Pemohon' ||
                      data.status_permohonan == 'Menunggu Penilaian Teknis' ||
                      data.status_permohonan == 'Menunggu Verifikasi Dokumen'
                    " variant="light" size="sm"
                      class="rounded-pill text-warning font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="edit(data.id, 'edit', data)">
                      <i class="fa fa-edit mr-2"></i>
                      <span>Edit</span>
                    </b-button>

                    <!-- Tombol Submit Ulang / Revisi (Kondisional Verdok) -->
                    <b-button v-else-if="data.status_verdok == 'Perbaikan Persyaratan'" variant="light" size="sm"
                      class="rounded-pill text-warning font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="edit(data.id, 'revisi', data)">
                      <i class="fa fa-redo mr-2"></i>
                      <span>Submit Ulang</span>
                    </b-button>

                    <!-- Tombol Detail (Default) -->
                    <b-button v-else variant="light" size="sm"
                      class="rounded-pill text-primary font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="$router.push('/app/permohonan/detail/' + data.id)">
                      <i class="fa fa-eye mr-2"></i>
                      <span>Detail</span>
                    </b-button>

                    <!-- Tombol Delete (Kondisional) -->
                    <b-button v-if="
                      data.status_permohonan == 'Permohonan telah disubmit oleh pemohon' ||
                      data.status_permohonan == 'Permohonan telah dibuat oleh pemohon'
                    " variant="light" size="sm"
                      class="rounded-pill text-danger font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="deletePermohonan(data.id)">
                      <i class="fa fa-trash mr-2"></i>
                      <span>Delete</span>
                    </b-button>

                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Widget>

    <b-modal body-class="bg-white" id="modal-bayar" title="Upload Bukti Pembayaran" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="File Bukti Pembayaran: *" label-for="username">
              <b-form-file placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." plain
                class="form-control" v-model="dataPerDokumen.bukti_pembayaran_pemohon" accept=".pdf"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmitPembayaran">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <ModalTracking v-model="showModalTracking" :progressPermohonan="progressPermohonan" />

    <ModalDownloadDokumen :selected-data="activeData" />
  </div>
</template>

<style>
table.table.b-table>thead>tr>th[aria-sort="ascending"]::after,
table.table.b-table>tfoot>tr>th[aria-sort="ascending"]::after {
  opacity: 1;
  content: "\2191";
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}
</style>

<script>
import Widget from "@/components/Widget/Widget";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";
import moment from "moment";
import { formatDate } from "../../helper/helpernew";
import ModalTracking from "../Perizinan/Components/ModalTracking.vue";
import ModalDownloadDokumen from "./Components/ModalDownloadDokumen.vue";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "Dynamic",
  components: { Widget, ClassicEditor, vSelect, ModalTracking, ModalDownloadDokumen },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      dataPermohonan: [],
      progressPermohonan: [],
      popoverShow: {},
      dataPerDokumen: {},
      showModalTracking: false,
      activeData: null
    };
  },

  mounted() {
    if (this.user.tipe_pemohon == 'swasta') {
      this.loaddata()
    } else if (this.user.tipe_pemohon == 'pemerintah') {
      this.$router.replace('/app/permohonan/non-berusaha/pemerintah')
    } else {
      this.$router.push('/app/dashboard')
    }
  },
  methods: {
    onClose(id) {
      this.popoverShow[id] = false;
    },
    format_date(val, format) {
      if (val) return moment(String(val)).format(format);
    },
    loaddata() {
      axios
        .get(
          this.baseapi +
          "api/permohonan_nonberusaha?filter=tipe_pemohon,=,Swasta;id_pembuat,=," +
          this.user.id + ";nomor_permohonan_revisi,=,",
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataPermohonan = response.data.data;
          ////console.log(this.dataPermohonan);
          this.initDatatable();
        })
        .catch((error) => {
          ////console.log(error);
          return error;
        });
    },
    async deletePermohonan(id) {
      Swal.fire({
        title: "Apa kamu yakin?",
        text: "Anda tidak akan dapat mengembalikan data ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Tutup",
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + "api/permohonan_nonberusaha/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire("Berhasil", "" + response.data.message + "", "success");
              $("#example").DataTable().destroy();
              this.loaddata();
            })
            .catch((error) => {
              ////console.log(error);
            });
        }
      });
    },
    edit(id, jenis, form) {

      if (jenis == 'revisi') {
        this.$loading(true)

        var formData = {
          "id_pembuat": form.id_pembuat,
          "tipe_pemohon": form.tipe_pemohon,
          "nama_pemohon": form.nama_pemohon,
          "jabatan_pemohon": form.jabatan_pemohon,
          "instansi_pemohon": form.instansi_pemohon,
          "alamat_pemohon": form.alamat_pemohon,
          "nik_pemohon": form.nik_pemohon,
          "npwp_pemohon": form.npwp_pemohon,
          "no_hp_pemohon": form.no_hp_pemohon,
          "no_telepon_pemohon": form.no_telepon_pemohon,
          "email_pemohon": form.email_pemohon,
          "provinsi": form.provinsi,
          "kabupaten": form.kabupaten,
          "kecamatan": form.kecamatan,
          "tanggal_permohonan": form.tanggal_permohonan,
          "jenis_kegiatan": form.jenis_kegiatan,
          "reklamasi": form.reklamasi,
          "nama_perairan": form.nama_perairan,
          "psn": form.psn,
          "skala_usaha": form.skala_usaha,
          "jenis_pnbp": form.jenis_pnbp,
          "luas": form.luas,
          "panjang_konservasi_kabel": form.panjang_konservasi_kabel,
          "panjang_nonkonservasi_kabel": form.panjang_nonkonservasi_kabel,
          "panjang_konservasi_pipa_air": form.panjang_konservasi_pipa_air,
          "panjang_nonkonservasi_pipa_air": form.panjang_nonkonservasi_pipa_air,
          "panjang_konservasi_pipa_lain": form.panjang_konservasi_pipa_lain,
          "panjang_nonkonservasi_pipa_lain": form.panjang_nonkonservasi_pipa_lain,
          "kedalaman": form.kedalaman,
          "bujur": form.bujur,
          "lintang": form.lintang,
          "catatan_verdok": form.catatan_verdok,
          "nilai_investasi": form.nilai_investasi,
          "serapan_tenaga_kerja": form.serapan_tenaga_kerja,
        }

        axios
          .put(
            this.baseapi + "api/permohonan_nonberusaha/submitUlang/" + id, formData,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          ).then((res) => {

            localStorage.setItem('id_permohonan', res.data.data.id)
            localStorage.setItem('tipe_pemohon', 'Swasta')
            this.$router.push('/app/permohonan/form?jenis=edit')
          }).catch((err) => {
            this.$toasted.error(err.response.data.message);
          }).finally(() => {
            this.$loading(false)
          })
      } else {
        localStorage.setItem('id_permohonan', id)
        localStorage.setItem('tipe_pemohon', 'Swasta')
        this.$router.push('/app/permohonan/form?jenis=' + jenis)
      }
    },

    loadProgress(id) {
      axios
        .get(
          this.baseapi +
          "api/status_permohonan_nonberusaha?filter=id_permohonan,=," +
          id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.progressPermohonan = response.data.data;
          this.showModalTracking = true
        })
        .catch((error) => {
          ////console.log(error);
          return error;
        });
    },

    getBayar(id) {
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPerDokumen = response.data.data;
          this.$bvModal.show("modal-bayar");
        })
        .catch((error) => {
          ////console.log(error);
          return error;
        });
    },

    onSubmitPembayaran() {
      ////console.log("cok");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-bayar");
      });
      this.$loading(true);
      let formData = new FormData();
      formData.append("bukti_pembayaran_pemohon", this.dataPerDokumen.bukti_pembayaran_pemohon);
      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/updatePembayaran/" + this.dataPerDokumen.id,
          formData,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$loading(false);
          this.$toasted.success("Berhasil Disimpan");
          this.dataPerDokumen = [];
          this.loaddata();
          return res;
        })
        .catch((err) => {
          this.$loading(false);
          ////console.log(err);
          this.$toasted.error(err.response.data.message);
          // this.$bvModal.hide('modal-pembayaran')
          return err;
        });
    },

    openModalDownload(data) {
      this.activeData = data;
      this.$bvModal.show('modal-download-dokumen');
    },
    countAvailableFiles(data) {
      if (!data) return 0;
      let count = 0;

      if (data.file_tagihan_iii || data.file_tagihan_ii || data.file_tagihan_i) count++;
      if (data.bukti_pembayaran) count++;
      if (data.bukti_pembayaran_pemohon) count++;
      if (data.filename_final_surat_tugas || data.filename_konsep_surat_tugas) count++;
      if (data.filename_final_undangan || data.filename_konsep_undangan) count++;
      if (data.file_persetujuan) count++;

      return count;
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment("DD MMM YYYY");
        var t = $("#example").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: "Bfrtip",
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            if (aData[6] === 'Perbaikan Persyaratan' || aData[6] === 'Penolakan') {
              $(nRow).removeClass('row-setujui').addClass('row-tolak');
            } else if (aData[6] === 'Terbit') {
              $(nRow).removeClass('row-tolak').addClass('row-setujui');
            } else {
              $(nRow).removeClass('row-tolak row-setujui');
            }
            return nRow;
          },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // ////console.log(meta.row);
                // ////console.log(type == 'export' ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
              rowCallback: function (row, data, index) {
                ////console.log(data);
                if (data[0] == "OK") {
                  $(row).addClass("green");
                } else if (data[0] == "Before") {
                  $(row).addClass("orange");
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            {
              text: '<i class="fa fa-plus"></i> Tambah',
              className: "btn btn-primary",
              action: function (e, dt, node, config) {
                localStorage.removeItem("id_permohonan");
                localStorage.setItem("tipe_pemohon", "Swasta");
                window.location = "/app/permohonan/form";
              },
            },
            {
              extend: "excelHtml5",
              title: "DATA PEMOHON",
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: "btn text-white btn-success",
              exportOptions: {
                columns: [1, 2, 3, 4, 5],
                orthogonal: "export",
              },
              filename: function () {
                var today = new Date();
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  "-" +
                  (today.getMonth() + 1) +
                  "-" +
                  today.getDate();

                return "Data Pemohon Nonberusaha Swasta " + date;
              },
            },
          ],
        });

        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },
  },
};
</script>

<style src="./Elements.scss" lang="scss" />